import { useState, useCallback } from 'react';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { WALLBOARD_LEVELS } from '@components/wallboard/constants';

export interface UseManageWallboardLevelParams {
  wallboardSelectedLevel: string;
  navigateTitle: string;
}

const useManageWallboardLevel = ({ wallboardSelectedLevel, navigateTitle }: UseManageWallboardLevelParams) => {
  const [activeTab, setActiveTab] = useState(wallboardSelectedLevel);
  const navigation = useNavigation();

  useFocusEffect(
    useCallback(() => {
      const activeLevelData = WALLBOARD_LEVELS.find((l) => l.value === wallboardSelectedLevel);
      if (!activeLevelData) return;
      const title = `Wallboard - ${activeLevelData.text} - ${navigateTitle}`;
      navigation.setOptions({ title });
    }, [wallboardSelectedLevel])
  );

  return {
    activeTab,
    setActiveTab,
    levels: WALLBOARD_LEVELS,
  };
};

export default useManageWallboardLevel;
